<template>
  <header class="masthead">
    <div class="bg-slide" :class="{ active: showA }" :style="{ backgroundImage: bgA }"></div>
    <div class="bg-slide" :class="{ active: !showA }" :style="{ backgroundImage: bgB }"></div>
    <div class="container">
      <div class="intro-text">
        <div class="intro-heading text-uppercase"><span>ART AND MUSIC</span></div>
        <a id="services-center-button" class="btn btn-primary btn-xl text-uppercase js-scroll-trigger" role="button"
           href="#services">μαθετε περισσοτερα</a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppSlider",
  data() {
    return {
      background_images: [
        'url("assets/img/main_images/saxophone4k.jpg")',
        'url("assets/img/main_images/saxophone-main.jpg")',
        'url("assets/img/main_images/saxophoneBlurred.jpg")',
        'url("assets/img/main_images/trumpet.jpg")',
        'url("assets/img/main_images/trumpet-2717460.jpg")',
        'url("assets/img/main_images/clarinet.jpg")',
        'url("assets/img/main_images/clarinet_2.jpg")',
      ],
      bgA: 'url("assets/img/main_images/saxophoneBlurred.jpg")',
      bgB: '',
      showA: true,
    }
  },
  methods: {
    change_image() {
      setInterval(() => {
        const next = this.background_images[Math.floor(Math.random() * this.background_images.length)]
        if (this.showA) {
          this.bgB = next
          this.showA = false
        } else {
          this.bgA = next
          this.showA = true
        }
      }, 7000)
    }
  },
  mounted() {
    this.change_image()
  }
}
</script>

<style scoped>
.masthead {
  position: relative;
  background-color: #343a40;
  display: flex;
}

.bg-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity 2s ease-in-out;
}

.bg-slide.active {
  opacity: 1;
}

.container {
  position: relative;
  z-index: 2;
}

#services-center-button {
  color: #000000;
}
</style>
